// Regras de desconto/comissão da CEMIG (Grupo B) e comissões do Grupo A
export const CEMIG_DEFAULT_RULE = { min: 22, max: 30 };

const CEMIG_SPECIAL_PARTNERS = {
  "cristianovaladao@outlook.com": { min: 28, max: 35 },
};

export const getCemigRule = (...emails) => {
  for (const e of emails) {
    const rule = CEMIG_SPECIAL_PARTNERS[(e || "").trim().toLowerCase()];
    if (rule) return rule;
  }
  return CEMIG_DEFAULT_RULE;
};

export const cemigCommission = (discount, rule) => {
  const d = parseFloat(discount);
  if (Number.isNaN(d)) return "";
  return Math.round((rule.max - d) * 100) / 100;
};

export const clampCemigDiscount = (discount, rule) => {
  const d = parseFloat(discount);
  if (Number.isNaN(d)) return null;
  if (d < rule.min) return rule.min;
  if (d > rule.max) return rule.max;
  return null;
};

export const GROUP_A_COMMISSION = { CELESC: 2, CEMIG: 5, COPEL: 4, RGE: 5 };
